import { Users } from 'lucide-react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import type { Evento } from '@/types'
import { formatDateRange } from '../utils'

interface EventSummaryCardProps {
  evento: Evento
}

export function EventSummaryCard({ evento }: EventSummaryCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Users className="h-5 w-5 text-primary" />
          Resumo do evento
        </CardTitle>
        <CardDescription>Confirme as informações antes de finalizar o cadastro</CardDescription>
      </CardHeader>
      <CardContent className="space-y-3 text-sm">
        <div>
          <p className="text-xs uppercase text-muted-foreground">Evento</p>
          <p className="text-base font-semibold">{evento.titulo}</p>
        </div>
        <div>
          <p className="text-xs uppercase text-muted-foreground">Período</p>
          <p>{formatDateRange(evento)}</p>
        </div>
        {evento.local && (
          <div>
            <p className="text-xs uppercase text-muted-foreground">Local</p>
            <p>{evento.local}</p>
          </div>
        )}
        {evento.capacidade && (
          <div>
            <p className="text-xs uppercase text-muted-foreground">Capacidade</p>
            <p>{evento.capacidade} vagas disponíveis</p>
          </div>
        )}
      </CardContent>
    </Card>
  )
}
